import {
    addCompanySubDomain,
    addEmail,
    addSnsOauthData,
    collectGtm,
    getEmail,
    getJoinUseInttId,
    getPlanId,
    getUser,
    getUserId,
    initUser,
    isGuestUser,
    isInitUser,
    isSnsSignUp,
    isWebView
} from "../../store.js";
import {MorningMateBusinessEmailInputView} from "../../morningmate-business-email-input-view/index.js";
import {BusinessEmailView} from "../../view/BusinessEmailView.js";
import {GuestEmailView} from "../../view/GuestEmailView.js";
import {EmailAuthView} from "../../view/EmailAuthView.js";
import {UserProfileView} from "../../view/UserProfileView.js";
import {CompanyInviteUserView} from "../../view/CompanyInviteUserView.js";
import {CompanyProfileView} from "../../view/CompanyProfileView.js";
import {SubDomainSearchView} from "../../view/SubDomainSearchView.js";
import {CompanyInfoView} from "../../view/CompanyInfoView.js";
import {
    mobileOpenShareContents,
    mobileOpenTextMessageApp,
    mobileSignIn,
    sendMoveMobileSignUpPage,
    mobileCloseFunc
} from "../../../../bridge/renewal-signup/index.js";
import {checkDuplicateEmail, getCompanyInfo} from "../../../../apiCall/signup/index.js";
import {CompanyJoinWaitView} from "../../view/CompanyJoinWaitView.js";
import {ERROR_CODE, GUEST_PLAN_ID} from "../../constant.js";
import {InputValidator} from "../input-validate/inputValidation.js";
import {LoadingPopup} from "../../components/popup/LoadingPopup.js";
import {MorningmateAppSumo} from "../../view/MorningmateAppSumo.js";
import {BusinessSnsView} from "../../view/BusinessSnsView.js";
import {ProjectInvitationView} from "../../view/ProjectInvitationView.js";
import {InvitationUserFormView} from "../../view/InvitationUserFormView.js";
import {InvitationCompanyView} from "../../view/InvitationCompanyView.js";
import {InvitationEmailView} from "../../view/InvitationEmailView.js";


const routerMap = {
    'businessEmail': {
        title: 'businessEmail',
        loadView: loadBusinessEmailView,
    }, 'guestEmail': {
        title: 'guestEmail',
        loadView: loadGuestEmailView,
    }, 'emailAuth': {
        title: 'emailAuth',
        loadView: loadEmailAuthView,
    }, 'userProfileInput': {
        title: 'userProfileInput',
        loadView: loadProfileView,
    }, 'companyInvite': {
        title: 'companyInvite',
        loadView: loadCompanyInviteView,
    }, 'searchCompanySubDomain': {
        title: 'searchCompanySubDomain',
        loadView: loadSearchCompanyBySubDomain,
    }, 'companyInfo': {
        title: 'companyInfo',
        loadView: loadCompanyInfoView
    }, 'companyInfoInput': {
        title: 'companyInfoInput',
        loadView: loadCompanyInfoInputView
    }, 'companyJoinWait': {
        title: 'companyJoinWait',
        loadView: loadCompanyJoinWaitView
    }, 'morningmateBusinessEmailInput': {
        title: 'morningmateBusinessEmailInput',
        loadView: loadMorningMateBusinessEmailInputView
    } , 'businessSns': {
        title: 'businessSns',
        loadView: loadBusinessSnsView
    }, 'projectInvitation': {
        title: 'projectInvitation',
        loadView: loadProjectInvitationView
    }, 'invitationUserForm': {
        title: 'invitationUserForm',
        loadView: loadInvitationUserFormView
    }, 'invitationCompany': {
        title: 'invitationCompany',
        loadView: loadInvitationCompanyView
    }, 'invitationEmail': {
        title: 'invitationEmail',
        loadView: loadInvitationEmail
    }
}

const customHistory = [];

function addBackEvent() {
    window.onpopstate = function (event) {
        if (customHistory.length <= 1) {
            Mutil.removeLocal("SNS_ACCOUNT_SETTING")
            escapeSignUpPageByBack();
            return;
        }
        if (isNotWorkBackButton()) {
            history.pushState({}, "", `${location.search}`);
            return;
        }
        const curPage = customHistory.pop().title;
        const prevPage = customHistory.pop().title;
        Mutil.mlog(`뒤로 가기 : ${curPage} >>> ${prevPage}`);
        if (isFirstPage(prevPage)) {
            const planId = getPlanId();
            routerMap[prevPage].loadView(planId);
            return;
        }
        routerMap[prevPage].loadView();
    };
}

function escapeSignUpPageByBack() {
    if (isWebView()) {
        sendMoveMobileSignUpPage()
        return;
    }
    history.back();
}

function isFirstPage(routerTitle = "") {
    const firstPageTitles = ['businessEmail', 'businessSns']
    return firstPageTitles.includes(routerTitle);
}

function isNotWorkBackButton() {
    return isCompanyWaitView() || isEmployeeInviteView();
}

function isEmployeeInviteView() {
    return $("#welcomeStep").is(":visible");
}

function isCompanyWaitView() {
    if (customHistory.length === 0) {
        return false;
    }
    const curPageHistory = customHistory[customHistory.length - 1];
    return curPageHistory.title === "companyJoinWait"
}

function addCustomHistory(title = "") {
    history.pushState({title}, "", convertSignupUrl(title));
    if (Mutil.empty(title) || !routerMap.hasOwnProperty(title)) {
        return;
    }
    customHistory.push({title});
}

function convertSignupUrl(title = '') {
    if(isFirstPage(title)) {
        const url = new URL(`${location.origin}${location.pathname}?${title}`)
        const params = new URLSearchParams(document.location.search);
        [...params].forEach(([k,v]) => {
            url.searchParams.set(k, v);
        })
       return url.toString();
    }

    return `?${title}`;
}


function drawView(props) {
    const {
        viewModule = Mutil.noop,
        title = '',
        layer = $("")
    } = props;
    addCustomHistory(title);

    // @Todo rule 등록...
    const isChangeAll = layer.length === 0;
    if (isChangeAll) {
        emptySignUpView();
        viewModule();
        return;
    }

    viewModule(layer);
}

// 가입 이메일 입력 뷰
function loadBusinessEmailView(planId = "") {
    initUser(false, planId)
    drawBusinessEmailView(planId);
}

function drawBusinessEmailView(planId = "") {
    if (Mutil.empty(planId)) {
        Mutil.mlog("플랜이 비어있습니다.");
        return;
    }

    setTimeout(() => {
        collectGtm("new_signup2");
    } , 1500)

    drawView({
        title: 'businessEmail',
        viewModule: () => {
            new BusinessEmailView($("body"), {
                mainText: getBusinessPageMainText(planId),
                subText: getBusinessPageSubText(planId),
                guestPageButtonText: i18next.t(login.startAsAGuest),
            });
        }
    });
}
function getBusinessPageMainText(planId) {
    if (!Often.isGlobal()) {
        return i18next.t(login.startFreeTrial);
    }

    if (planId.indexOf("BUSINESS") > -1 && Often.isGlobal() && Internationalization.getCurrentLanguage().includes('en')) {
        return "Enjoy the Morningmate Boost!"
    }

    return i18next.t(planId.indexOf("BUSINESS") > -1 ? login.useForFree : login.useForFreeMorningmate)
}

function getBusinessPageSubText(planId) {
    if (Often.isGlobal()) {
        return getBusinessPageSubTextByMorningmate(planId);
    }

    const Internationalization = Mutil.requireIIFE("Internationalization");
    const isKorea = Internationalization.getCurrentLanguage().toLowerCase() === 'ko';
    if (!isKorea) {
        return i18next.t(login.useForFree);
    }

    const PRO_PLAN = "PRO";
    const isProPlan = Mutil.n2v(planId).toUpperCase().indexOf(PRO_PLAN) > -1;
    const productName = isProPlan ? (window.isHideBasic ? "" : "프로") : "베이직";

    return `비즈니스 ${productName} 버전을 ${i18next.t(window.isHideBasic ? login.useForFree14Days : login.useForFree)}`
}

function getBusinessPageSubTextByMorningmate(planId) {
    const Internationalization = Mutil.requireIIFE("Internationalization");
    if(!Internationalization.getCurrentLanguage().toLowerCase().includes("en")) {
        return `${i18next.t(login.starFreeTrialDesc)}`
    }
    if(planId.indexOf("BUSINESS") > -1) {
        return `No credit card needed. Free forever.`;
    }

    if(planId.indexOf("PRO") > -1) {
        return `No credit card needed. <br /> You can continue, upgrade, or downgrade after.`;
    }

    return `No credit card needed. Free forever.!`
}

function loadBusinessEmailViewWithEmail(planId = "", email = "") {
    initUser(false, planId)
    addEmail(email);
    drawBusinessEmailView(planId);

}


// 가입 이메일 입력 뷰
function loadGuestEmailView(planId = '', ERR_CD = '') {
    initUser(true, planId);
    drawView({
        title: 'guestEmail',
        viewModule: () => {
            new GuestEmailView($("body"), {
                mainText: i18next.t(login.crgstaccnt),
                subText: i18next.t(login.invtdprjct),
            });
        }
    });

    if(ERR_CD === ERROR_CODE.BLOCK_DOMAIN) {
        Mutil.toast("error", i18next.t(exception.error.limitEmail));
    }
}

// 이메일 인증 번호 입력 뷰
function loadEmailAuthView() {
    if(!isGuestUser()) {
        if(window.CONNECT_INVITE_KEY) {
            collectGtm("new_joinup2_c");
        } else if(isSnsSignUp()) {
            collectGtm("new_signup2");
        } else {
            collectGtm("new_signup3");
        }
    }

    drawView({
        title: 'emailAuth',
        viewModule: () => {
            const email = getEmail();
            new EmailAuthView($("body"), {
                mainText: i18next.t(common.inputValue, {val: $t(common.confirmVerificationCode)}),
                subText: email
            })
        }
    });
}

async function loadFirstEmailAuthView(planId = "", email = "") {
    if (!InputValidator.isValidEmail(email)) {
        loadBusinessEmailViewWithEmail(planId, email);
        return
    }
    new LoadingPopup($("body"), {loadingText  : i18next.t(common.wait), isNoLoadingText: true});
    // 체크
    const {ERR_CD} = await checkDuplicateEmail(email);
    const isDuplicateId = Mutil.n2v(ERR_CD) !== ERROR_CODE.SUCCESS;
    if (isDuplicateId) {
        loadBusinessEmailViewWithEmail(planId, email);
        return
    }

    initUser(false, planId);
    addEmail(email);
    loadEmailAuthView();
}

// 사용자 정보 입력 뷰
async function loadProfileView(planId = '', snsOauthData = {}) {
    const isSnsSignUp = Object.values(snsOauthData).length > 0;
    if (isSnsSignUp) {
        if(!isInitUser() && (Mutil.exist(planId))) {
            initUser(planId === GUEST_PLAN_ID, planId);
        }

        addSnsOauthData(snsOauthData);
    }
    // 구글 회원 가입이면  new_signup2_b, 일반 이메일 회원 가입이면 new_signup4

    setTimeout(() => {

        if(!isGuestUser()) {
            if(window.CONNECT_INVITE_KEY) {
                collectGtm("new_joinup3_c");
                return;
            }

            if(Often.isGlobal() || !isSnsSignUp) {
                collectGtm("new_signup4");
                return;
            }

            collectGtm("new_signup3");
        }
    }, 1500);



    drawView({
        title: 'userProfileInput',
        viewModule: () => {
            const Internationalization = Mutil.requireIIFE("Internationalization");
            const isEn = Internationalization.getCurrentLanguage().toLowerCase().includes('en');
            const userId = getUserId();
            new UserProfileView($("body"), {
                mainText: i18next.t(login.inuputUserInfo),
                subText: isEn ? `start with ${userId}` : i18next.t(login.enterUserInfo),
            });
        }
    });

}


// 회사 초대 정보 뷰
function loadCompanyInviteView() {
    if(Often.isGlobal()) {
        collectGtm("new_signup5");
    } else {
        isSnsSignUp() ? collectGtm("new_joinup_b") : collectGtm("new_joinup1_a");
    }

    drawView({
        title: 'companyInvite',
        viewModule: () => {
            new CompanyInviteUserView($("body"), {
                mainText:i18next.t(login.createCompanyAndJoin),
                subText: i18next.t(login.createCompanyAndJoinByInvitation),
            });
        }
    });
}


function loadCompanyInfoInputView() {
    //@todo 입력 값 검증(user)
    if(Often.isGlobal()) {
        collectGtm("new_signup6");
    } else if(isSnsSignUp()) {
        collectGtm("new_signup4");
    } else {
        collectGtm("new_signup5");
    }

    drawView({
        title: 'companyInfoInput',
        viewModule: () => {
            const getSubText = () => {
                const Internationalization = Mutil.requireIIFE("Internationalization");
                const isKorea = Internationalization.getCurrentLanguage().toLowerCase() === 'ko';
                if (isKorea) {
                    return "아래 정보를 모두 입력해 주세요.";
                }

                return i18next.t(login.common.enter, {val: $t(common.companyName)});
            }
            new CompanyProfileView($("body"), {
                mainText: i18next.t(login.createNewCompany),
                subText: i18next.t(login.startWithAdmin),
            });
        }
    });
}

function loadInviteUserView(COMPANY_INFO_JSON = {}) {
    //@todo 입력 값 검증(user)
    if(Often.isGlobal()) {
        collectGtm("new_signup7", getEmail());
    }

    if(window?.isFuncPhoneGetPop) {
        Mutil.mlog("휴대폰 번호 받을 때 초대하기 페이지는 생략")
        return;
    }

    drawView({
        title: 'inviteUser',
        viewModule: () => {
            const passJson = {
                ...COMPANY_INFO_JSON,
                "WEBVIEW_YN": isWebView() ? "Y" : "N",
                "isSns": isSnsSignUp(),
                mobileOpenShareContents: !isWebView() ? Mutil.noop : mobileOpenShareContents,
                mobileOpenTextMessageApp: !isWebView() ? Mutil.noop : mobileOpenTextMessageApp,
                mobileCloseFunc: !isWebView() ? Mutil.noop : mobileCloseFunc,
                mobileSignInFunc: !isWebView() ? Mutil.noop : () => {
                    mobileSignIn({...getUser().getCreateNewCompanyInfoJson()});
                }
            }

            if (window?.isInviteV2 || Often.isServerModeByHost("DEV_TEST")){
                InviteLayer.toggleInviteEmplLayer({passJson});
            } else {
                WelcomeStep.openWelcomeStep(passJson);
            }
        }
    });
}

// 새 회사 정보 입력 뷰
function loadSearchCompanyBySubDomain() {
    //@todo 입력 값 검증(user)
    if(Often.isGlobal()) {
        collectGtm("new_joinup1");
    } else {
        collectGtm(isSnsSignUp() ? "new_joinup2_a" : "new_joinup1_b");
    }

    drawView({
        title: 'searchCompanySubDomain',
        viewModule: () => {
            new SubDomainSearchView($("body"), {
                mainText: i18next.t(login.joinCompany),
                subText: i18next.t(login.invitationDescription),
            })
        }
    });
}

// 회사 정보 확인 뷰
function loadCompanyInfoView(isInvite = false) {
    if(Often.isGlobal()) {
        isInvite ? collectGtm("new_joinup1_a") : collectGtm("new_joinup2");
    } else {
        collectGtm(isSnsSignUp() ? "new_joinup3_a" : "new_joinup2_b");
    }
    drawView({
        title: 'companyInfo',
        viewModule: async () => {
            const joinUseInttId = getJoinUseInttId();
            Mutil.load({type: "circle", $area: $("body")});
            emptySignUpView()
            const {USE_INTT_NM = "", EMPL_REC = [], SUB_DOM = ""} = await getCompanyInfo(joinUseInttId);
            addCompanySubDomain(SUB_DOM);
            new CompanyInfoView($("body"), {
                mainText: i18next.t(login.confirmCompany),
                subText: i18next.t(login.confirmCompanyDesc),
                companyName: USE_INTT_NM,
                employeeList: EMPL_REC,
            });
        }
    });
}

// 회사 가입 요쳥 완료 뷰
function loadCompanyJoinWaitView(userId = getUserId()) {
    if (Mutil.empty(userId)) {
        Mutil.toast("error", i18next.t(main.alert.wrongApproach));
        return;
    }

    //@todo 입력 값 검증(user)
    if(isInitUser()) {
        if(Often.isGlobal()) {
            collectGtm("new_joinup3");
        } else if(window.CONNECT_INVITE_KEY) {
            collectGtm("new_joinup4_c");
        } else {
            collectGtm(isSnsSignUp() ? "new_joinup4_a" : "new_joinup3_b");
        }
    }


    drawView({
        title: 'companyJoinWait',
        viewModule: () => {
            new CompanyJoinWaitView($("body"), {
                mainText: i18next.t(login.joinRequestComplete),
                userId,
            })
        }
    });
}

function loadBusinessSnsView(planId) {
    initUser(false, planId);
    //기본적으로 페이지 로드되는 시점에 호출되는 함수에다가 collect하면 GA태그 자체가 안붙어서 이벤트가 캔슬되는 케이스가 생길 수 있음
    //보통 이런경우 setTimeout으로 딜레이 주고 쏘는편(main 참고)
    setTimeout(() => {
        collectGtm("new_signup1");
    }, 1500);

    drawView({
        title: 'businessSns',
        viewModule: () => {
           new BusinessSnsView($("body"), {
               mainText : getBusinessPageMainText(planId),
               subText : getBusinessPageSubText(planId),
           });
        }
    });
}

// 가입 이메일 입력 뷰
function loadMorningMateBusinessEmailInputView() {
    collectGtm("new_signup2");
    drawView({
        title: 'morningmateBusinessEmailInput',
        viewModule: () => {
            MorningMateBusinessEmailInputView.draw()
        }
    });
}

function emptySignUpView() {
    Mutil.removeLocal("SNS_ACCOUNT_SETTING");
    $("body > *:not(#welcomeStep,#popupDraw,#inviteEmployeeLayer2)").remove();
}

function moveSignInPage() {
    const url = new URL(`${location.origin}/signin.act`)

    const isInviteKeyExist = Mutil.exist(window.CONNECT_INVITE_KEY)
    const viewId = getViewId()
    const allowedViews = new Set(['companyJoinWait', 'projectInvitation'])
    if (isInviteKeyExist && allowedViews.has(viewId)) {
        url.searchParams.set('INVT_KEY', window.CONNECT_INVITE_KEY)
        url.searchParams.set('complete', 'true')
    }

    location.href = url.toString()
}

// 모바일 웹뷰에서 모바일이 직접 호출에서 사용하고 있습니다.
function loadSocialLoginSuccessByMobile(snsOauthDataStr = "") {
    let snsOauthData = {};
    try {
        snsOauthData = JSON.parse(snsOauthDataStr);
    } catch (e) {
        Mutil.mlog("모바일에서 잘못된 정보가 넘어 왔습니다.(JSON 파싱에러)");
    }
    loadSocialLoginSuccess(snsOauthData);
}

async function loadSocialLoginSuccess(snsOauthData = {}) {
    //모바일에서 호출용
    const existData = Object.values(snsOauthData).length > 0;
    const isGmailOAuth = Often.null2Void(new URL(location.href).searchParams.get('gmail_workspace_oauth')).includes('true');

    if (!existData) {
        Mutil.mlog("소셜 인증 정보가 없습니다.");
        return;
    }


    const signInBySns =  (snsOauthData) =>  {
        if (isWebView()) {
            mobileSignIn(snsOauthData);
            return;
        }

        const CommonLogin = Mutil.requireIIFE("CommonLogin");
        CommonLogin.goLogin(snsOauthData);
    }



    // 회원 가입 페이지가 아니면 로그인를 시켜서 오류 메시지를 보게끔한다. (signin.act , miniSignIn.act)
    if(!Mutil.isAct("/newSignup.act")) {
        signInBySns(snsOauthData);
        return;
    }


    // 체크
    const {ERR_CD} = await checkDuplicateEmail(snsOauthData.USER_ID, snsOauthData.ID_GB);
    const isDuplicateId = Mutil.n2v(ERR_CD) !== ERROR_CODE.SUCCESS;
    if (isDuplicateId) {
        getUser().signInWithTwoFactor({PASS_JSON : snsOauthData});
        return
    }

    if (isGmailOAuth) {
        Mutil.setLocalJson("SNS_ACCOUNT_SETTING", {...snsOauthData})
        Mutil.open("/newSignup.act?account=sns", "_blank");
        return;
    }

    if(isInitUser()) {
        loadProfileView(getPlanId(), snsOauthData);
        return
    }

    const CommonJoin = Mutil.requireIIFE("CommonJoin");
    const socialLoginDefaultPlanId = Often.isGlobal() ? CommonJoin.getDefaultPlanId() : GUEST_PLAN_ID;
    loadProfileView(socialLoginDefaultPlanId, snsOauthData);
}

function loadMorningmateAppSumoView() {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    initUser(false, `appSumo_${token}`);
	addEmail(urlParams.get('user_id'))
    drawView({
        title: 'morningmateAppSumo',
        viewModule: () => {
            new MorningmateAppSumo($("body"), {
                mainText: 'Sign up with App Sumo',
                subText: `Your plan is ${window.appSumoPlan}`,
                token: token
            });
        }
    });
}


function moveNewSignUpPage(snsOauthData = {}) {
    const existData = Object.values(snsOauthData).length > 0;
    const isGmailOAuth = Often.null2Void(new URL(location.href).searchParams.get('gmail_workspace_oauth')).includes('true');

    if (existData) {
        Mutil.setLocalJson("SNS_ACCOUNT_SETTING", {...snsOauthData})
    }

    if (isGmailOAuth) {
        Mutil.open("/newSignup.act?account=sns", "_blank");
        return;
    }

    location.href = "/newSignup.act?account=sns";
}

function moveIndexHomePage() {
    location.href = "/";
}

function loadProjectInvitationView(planId = '') {
    initUser(false, planId)
    drawView({
        title: 'projectInvitation',
        viewModule: () => {
            new ProjectInvitationView($('body'), {
                mainText: i18next.t(login.invite.joinProjectTitle),
                subText: i18next.t(login.invite.joinProjectSubtitle),
            })
        }
    })
}

function loadInvitationUserFormView() {
    drawView({
        title: 'invitationUserForm',
        viewModule: () => {
            const Internationalization = Mutil.requireIIFE('Internationalization')
            const isEn = Internationalization.getCurrentLanguage().toLowerCase().includes('en')
            const userId = getUserId()
            new InvitationUserFormView($('body'), {
                mainText: i18next.t(login.inuputUserInfo),
                subText: isEn ? `start with ${userId}` : i18next.t(login.enterUserInfo),
            })
        }
    })
}

function loadInvitationCompanyView() {
    drawView({
        title: 'invitationCompany',
        viewModule: async () => {
            Mutil.load({
                type: 'circle',
                $area: $('body'),
            })
            emptySignUpView()

            const inttId = getJoinUseInttId()
            const {
                USE_INTT_NM = '',
                EMPL_REC = [],
                SUB_DOM = ''
            } = await getCompanyInfo(inttId)

            addCompanySubDomain(SUB_DOM)

            new InvitationCompanyView($('body'), {
                mainText: i18next.t(login.confirmCompany),
                subText: i18next.t(login.confirmCompanyDesc),
                companyName: USE_INTT_NM,
                employeeList: EMPL_REC,
            })
        }
    })
}

function loadInvitationEmail() {
    collectGtm("new_joinup1_c");
    drawView({
        title: 'loadInvitationEmail',
        viewModule: () => {
            new InvitationEmailView($('body'), {
                mainText: i18next.t(login.invite.joinCompanyTitle),
                subText: i18next.t(login.invite.joinCompanySubtitle, {
                    val: i18next.t(Often.isGlobal() ? $t(dictionary.morningmate) : $t(dictionary.flow))
                }),
            })
        }
    })
}

function getViewId() {
    const url = new URL(location.href)
    return url.search.substring(1)
}

export const SignUpViewChanger = {
    getViewId,
    loadBusinessEmailView, loadBusinessSnsView, loadEmailAuthView,
    loadProfileView,
    loadCompanyInviteView, loadCompanyInfoView, loadCompanyInfoInputView,
    moveSignInPage,
    loadSearchCompanyBySubDomain, loadCompanyJoinWaitView,
    loadGuestEmailView, addBackEvent,
    loadMorningMateBusinessEmailInputView,
    emptySignUpView, moveIndexHomePage,
    loadInviteUserView, moveNewSignUpPage,
    loadSocialLoginSuccess, loadFirstEmailAuthView,
    loadSocialLoginSuccessByMobile, loadMorningmateAppSumoView,
    loadProjectInvitationView, loadInvitationUserFormView, loadInvitationCompanyView, loadInvitationEmail
}


